import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import { DatePickerProps } from '@mui/x-date-pickers/DatePicker'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import ptBRLocale from 'date-fns/locale/pt-BR'
import { ITextFieldProps } from '../TextFieldComponent'
import * as S from './styles'
import './styles.css'

interface IDatePickerProps<TDate> extends DatePickerProps<TDate> {
  inputFieldProps?: ITextFieldProps
  className?: string
  required?: any
}

const DatePicker = (props: IDatePickerProps<any>) => {
  return (
    <LocalizationProvider
      adapterLocale={ptBRLocale}
      dateAdapter={AdapterDateFns}
    >
      <S.Calendar
        {...props}
        slots={{ textField: S.DateField }}
        slotProps={{ textField: { ...props?.inputFieldProps } }}
      />
    </LocalizationProvider>
  )
}

export { DatePicker }
export type { IDatePickerProps }
